import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

type PageLoadingStateProps = {
  label?: string;
  fullPage?: boolean;
  compact?: boolean;
};

export const PageLoadingState = ({
  label = "Cargando",
  fullPage = false,
  compact = false,
}: PageLoadingStateProps) => {
  const theme = useTheme();
  const reduceMotion = useMediaQuery("(prefers-reduced-motion: reduce)");

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        width: "100%",
        height: fullPage ? "100dvh" : "100%",
        minHeight: fullPage ? "100dvh" : compact ? 132 : { xs: 260, sm: 340 },
        display: "grid",
        placeItems: "center",
        bgcolor: "background.default",
        color: "text.secondary",
      }}
    >
      <Stack alignItems="center" spacing={compact ? 0.8 : 1.15}>
        <Box
          component="img"
          src="/assets/icons/ic-logo-light.png"
          alt="LyPro"
          sx={{
            width: compact ? 86 : 112,
            height: "auto",
            display: "block",
            filter: (logoTheme) => logoTheme.palette.mode === "light" ? "brightness(0.2)" : "none",
          }}
        />
        <Box
          aria-hidden="true"
          sx={{
            width: compact ? 128 : 172,
            height: 3,
            overflow: "hidden",
            borderRadius: 999,
            bgcolor: "action.hover",
            position: "relative",
            "&::after": {
              content: '""',
              position: "absolute",
              inset: 0,
              width: "42%",
              borderRadius: 999,
              background: `linear-gradient(90deg, transparent, ${theme.palette.primary.main}, ${theme.palette.primary.light}, transparent)`,
              animation: reduceMotion ? "none" : "pageLoadingSweep 1.55s ease-in-out infinite",
            },
            "@keyframes pageLoadingSweep": {
              from: { transform: "translateX(-130%)" },
              to: { transform: "translateX(250%)" },
            },
          }}
        />
        <Typography variant={compact ? "caption" : "body2"} sx={{ fontWeight: 600, textAlign: "center" }}>
          {label}
        </Typography>
      </Stack>
    </Box>
  );
};
